export enum Page {
    PROPERTY = 'property',
    MAP = 'map',
    GLOBAL = 'global',
    PROPERTY_INFORMATION = 'propertyInformation',
    TENANT = 'tenant',
    JOBS = 'jobs',
    ACCOUNTING = 'accounting',
    UNITS = 'units',
    TENANTS = 'tenants',
    VENDORS = 'vendors',
    USERS = 'users',
    USER_ROLES = 'userRoles',
    CLIENTS = 'clients',
    CLIENT_DATA_SOURCES = 'clientDataSources',
    CALENDAR = 'calendar'
}
